import React, { useMemo } from 'react';
import { Flipped, Flipper, spring } from 'react-flip-toolkit';
import { FlippedProps } from 'flip-toolkit/lib/types';
import { SpringConfig } from 'flip-toolkit/lib/springSettings/types';

function getWords(children: string | null, letters = false) {
  const words = children?.split(letters ? '' : /(\s)/).filter((v) => !!v);
  const keys = words?.reduce(
    (out, word, i) => {
      out.counter[word] = out.counter[word] ? out.counter[word] + 1 : 1;
      out.keymap[word + i] = word + out.counter[word];
      return out;
    },
    { counter: {}, keymap: {} } as {
      counter: Record<string, number>;
      keymap: Record<string, string>;
    },
  ).keymap;
  return { words, keys };
}

const onAppear = (el: HTMLElement) =>
  spring({
    config: { stiffness: 480, damping: 42 },
    onUpdate: (val: any) => {
      el.style.transform = `translateY(${(1 - val) * 10}px)`;
      el.style.opacity = `${val}`;
    },
  });

export const springConfig: SpringConfig = {
  stiffness: 480,
  damping: 30,
  overshootClamping: true,
};

const onExit = (el: HTMLElement, index: number, removeElement: () => void) => {
  spring({
    config: springConfig,
    onUpdate: (val: any) => {
      el.style.transform = `translateY(-${val * 10}px)`;
      el.style.opacity = `${1 - val}`;
    },
    onComplete: removeElement,
  });

  return () => {
    el.style.opacity = '';
    removeElement();
  };
};

/**
 * @param children
 * @param options
 * @constructor
 */
export const TextChangeTransition = ({
  children,
  letters,
  ...options
}: FlippedProps & { letters?: boolean; children: string | null }) => {
  const { words, keys } = useMemo(
    () => getWords(children, letters),
    [children, letters],
  );

  return (
    <Flipper flipKey={children}>
      {words?.map((word, i) => {
        const isSpace = word === ' ';
        return (
          <Flipped
            onAppear={onAppear}
            onExit={onExit}
            {...options}
            key={keys![word + i]}
            flipId={keys![word + i]}
          >
            <span style={{ display: 'inline-block' }}>
              {isSpace ? '\u00a0' : word}
            </span>
          </Flipped>
        );
      })}
    </Flipper>
  );
};
